{
    "CookiesDescription": "Usamos cookies para melhorar sua experiência no Akixi. Para ver mais informações sobre como e por que usamos cookies, consulte nossa {}Política de cookies{}.",
    "CookieConsentChangeMessage": "Se deseja alterar essa definição, pode fazê-lo abaixo.",
    "AcceptedAllCookiesMessage": "aceitou todos os cookies.\n {}",
    "AcceptedFunctionalCookiesMessage": "aceitou apenas cookies de funcionalidade.\n {}",
    "RejectedAllCookiesMessage": "Rejeitou todos os cookies. Isso significa que algumas funcionalidades da aplicação não vão funcionar.\n {}",
    "AcceptAllCookies": "Aceitar tudo",
    "AcceptFunctionalityCookies": "Aceitar cookies de funcionalidade",
    "RevokeAllCookies": "Revogar todo o consentimento",
    "RevokeStatisticsCookies": "Revogar consentimento de estatísticas",
    "RejectAllCookies": "Rejeitar tudo",
    "RejectionWarning": "Rejeitar todos os cookies significará que não poderá usar todas as funcionalidades da aplicação. \n\nSe precisar usar essas funcionalidades no futuro, precisará \"Aceitar cookies de funcionalidade\" na página de Política de cookies.",
    "NAME": "CookieConsent"
}